import { forwardRef, type Ref, type SVGProps } from "react";
const IconMultiFamilyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.817 2.48a2.5 2.5 0 0 1 2.366 0L27.3 8.012c.662.362 1.065 1.001 1.065 1.69v18.129c0 1.097-1.007 1.986-2.248 1.986H5.884c-1.241 0-2.248-.89-2.248-1.986V9.702c0-.688.403-1.327 1.065-1.689zm.092 18.247v7.091H9.455v-7.09c0-.603.48-1.092 1.071-1.092h3.312c.592 0 1.071.489 1.071 1.091m7.637 0v7.091H17.09v-7.09c0-.603.48-1.092 1.071-1.092h3.312c.592 0 1.072.489 1.072 1.091"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMultiFamilyFilledSVG);
ForwardRef.displayName = "IconMultiFamilyFilled";
export { ForwardRef as IconMultiFamilyFilled };
